import styled from "styled-components";
import DefaultContainer from "./DefaultContainer";

const Container = styled.div`
  display: flex;
  justify-content: center;
  background-color: #f8fafc;
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  width: 100%;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: #0f172a;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const SubTitle = styled.p`
  font-size: 17px;
  color: #64748b;
  line-height: 1.6;
`;

const Description = styled.p`
  font-size: 17px;
  line-height: 1.8;
  color: #64748b;
  text-align: center;
  max-width: 700px;

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

const FeaturesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
`;

const FeaturesTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: #0f172a;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const FeaturesList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureItem = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.3s ease;

  &:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  }
`;

const FeatureIcon = styled.div`
  font-size: 32px;
`;

const FeatureText = styled.p`
  font-size: 15px;
  color: #64748b;
  line-height: 1.6;
`;

const DownloadArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const DownloadLabel = styled.p`
  font-size: 15px;
  font-weight: 500;
  color: #64748b;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 480px) {
    flex-direction: column;
    width: 100%;
    max-width: 260px;
  }
`;

const DownloadButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;

  @media (max-width: 480px) {
    justify-content: center;
  }
`;

const AppStoreButton = styled(DownloadButton)`
  background: #0f172a;
  color: #ffffff;

  &:hover {
    background: #1e293b;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.3);
  }
`;

const PlayStoreButton = styled(DownloadButton)`
  background: #ffffff;
  color: #0f172a;
  border: 1.5px solid #e2e8f0;

  &:hover {
    border-color: #cbd5e1;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  }
`;

const ButtonLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
`;

const ButtonSmallText = styled.span`
  font-size: 10px;
  font-weight: 400;
  opacity: 0.7;
`;

const ButtonMainText = styled.span`
  font-size: 15px;
  font-weight: 600;
`;

const IconSvg = styled.svg`
  flex-shrink: 0;
`;

const AppleIcon = () => (
  <IconSvg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </IconSvg>
);

const PlayIcon = () => (
  <IconSvg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.302 2.302a1 1 0 010 1.38l-2.302 2.302L15.396 12l2.302-2.492zM5.864 2.658L16.8 8.99l-2.302 2.302L5.864 2.658z" />
  </IconSvg>
);

const LoNeSection = () => {
  return (
    <Container>
      <DefaultContainer>
        <Contents>
          <Header>
            <Title>LoNe</Title>
            <SubTitle>
              <strong>LoNe</strong>: Local Network - 장소 기반 소셜 네트워크
            </SubTitle>
          </Header>

          <Description>
            LoNe는 장소를 중심으로 사람들을 연결하는 새로운 소셜 네트워크 서비스입니다.
            <br />
            <br />
            당신이 방문한 장소에 대한 경험을 공유하고, 다른 사람들의 리뷰를 통해
            주변의 숨은 명소를 발견하세요.
          </Description>

          <FeaturesSection>
            <FeaturesTitle>주요 기능</FeaturesTitle>
            <FeaturesList>
              <FeatureItem>
                <FeatureIcon>👥</FeatureIcon>
                <FeatureText>
                  소셜 네트워크 서비스로 친구들과 장소 경험을 공유
                </FeatureText>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon>📝</FeatureIcon>
                <FeatureText>
                  장소를 연결하여 피드로 장소에 대한 리뷰 작성
                </FeatureText>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon>📍</FeatureIcon>
                <FeatureText>
                  GPS 기반으로 주변 장소의 리뷰를 실시간으로 확인
                </FeatureText>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon>🌐</FeatureIcon>
                <FeatureText>
                  웹 기반 서비스로 어디서나 쉽게 접속 가능
                </FeatureText>
              </FeatureItem>
            </FeaturesList>
          </FeaturesSection>

          <DownloadArea>
            <DownloadLabel>앱 다운로드</DownloadLabel>
            <ButtonGroup>
              <AppStoreButton
                href="https://apps.apple.com/us/app/lone/id6757098843"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AppleIcon />
                <ButtonLabel>
                  <ButtonSmallText>Download on the</ButtonSmallText>
                  <ButtonMainText>App Store</ButtonMainText>
                </ButtonLabel>
              </AppStoreButton>
              <PlayStoreButton
                href="https://play.google.com/store/apps/details?id=com.followingmoments.lone&hl=ko"
                target="_blank"
                rel="noopener noreferrer"
              >
                <PlayIcon />
                <ButtonLabel>
                  <ButtonSmallText>GET IT ON</ButtonSmallText>
                  <ButtonMainText>Google Play</ButtonMainText>
                </ButtonLabel>
              </PlayStoreButton>
            </ButtonGroup>
          </DownloadArea>
        </Contents>
      </DefaultContainer>
    </Container>
  );
};

export default LoNeSection;
